import { SET_COMPANIES } from '../../actions/company/getAllCompanies';

export const companies = (state = {}, action) => {
    switch(action.type) {
        case SET_COMPANIES:{
            return action.payload;
        }
        default:
            return state;
    }
}